// extracted by mini-css-extract-plugin
export default {"container":"e0-z","list":"f0-z"};